export default "__VITE_ASSET__38b2369c__"